'use strict';

// FILE JS FOR MAPS DEALER 

var instore = require('../checkout/instore');


instore.initialStoreMethodSelected();